import { fetchConfig } from './config-client.js';
import { mountIframe } from './iframe.js';
import { createPanel } from './panel.js';
import { exposeWindowAPI } from './window-api.js';

const EMBED_BASE = 'https://chat.attraxion.app';
const panels = new Map();

async function bootVenue(venue) {
  if (panels.has(venue)) return panels.get(venue);
  const config = await fetchConfig({ venue });
  if (!config || !config.enabled) return null; // silent bail
  const panel = createPanel();
  let iframe = null;
  const entry = {
    config, panel,
    open() {
      if (!iframe) {
        iframe = mountIframe(panel.panelEl, { src: `${EMBED_BASE}/chat/${encodeURIComponent(venue)}`, config });
      }
      panel.open();
    },
    close() { panel.close(); },
  };
  panels.set(venue, entry);
  return entry;
}

function renderBubble(host, config, onClick) {
  const btn = document.createElement('button');
  btn.className = 'attraxion-chat-bubble';
  btn.type = 'button';
  btn.setAttribute('aria-label', config.bot_name || 'Chat');
  btn.textContent = '\u{1F4AC}';
  if (config.theme_color) btn.style.background = config.theme_color;
  btn.addEventListener('click', (e) => { e.preventDefault(); onClick(); });
  host.appendChild(btn);
  return btn;
}

class AttraxionChatElement extends HTMLElement {
  async connectedCallback() {
    if (this._booted) return;
    this._booted = true;
    const venue = this.getAttribute('venue');
    if (!venue) return;
    const entry = await bootVenue(venue);
    if (!entry) return; // disabled/unknown → nothing rendered
    renderBubble(this, entry.config, () => entry.open());
  }
}

if (!customElements.get('attraxion-chat')) {
  customElements.define('attraxion-chat', AttraxionChatElement);
}
exposeWindowAPI({ bootVenue, panels });
